import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ul li:first-child {\n    padding-top: ", void 0], ["\n  ul li:first-child {\n    padding-top: ", ";\n  }\n\n  ul li span:first-child {\n    &::before {\n      content: '\\2013';\n      font-weight: normal;\n    }\n  }\n\n  li:last-child {\n    padding-bottom: 0;\n  }\n  padding-left: 0;\n  margin: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { verizonTheme as theme } from '@vds-core/theme';
import { calculateRem } from '@uie/javascript-style-helpers';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * Content that will be passed to the list.
   */
  children: PropTypes.node,

  /**
   * If provided, used as string that labels the element for accessibility.
   */
  ariaLabel: PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
};

function _calculatePadding() {
  return calculateRem(6);
}

var defaultProps = {
  calculatePadding: _calculatePadding,
  size: 'bodyLarge'
};
var StyledUl = /*#__PURE__*/styled.ul.withConfig({
  displayName: "StyledUl",
  componentId: "sc-1fa46xw-0"
})(_templateObject(), function (_ref) {
  var calculatePadding = _ref.calculatePadding,
      size = _ref.size;
  return calculatePadding(size);
});

var UnorderedList = function UnorderedList(props) {
  var ariaLabel = props.ariaLabel,
      id = props.id,
      nested = props.nested,
      children = props.children,
      calculatePadding = props.calculatePadding,
      size = props.size,
      className = props.className;
  var ulChildren = React.Children.map(children, function (listItem, index) {
    return /*#__PURE__*/React.cloneElement(listItem, _objectSpread(_objectSpread({}, listItem.props), {}, {
      key: index + 1,
      size: size
    }));
  });
  return /*#__PURE__*/React.createElement(StyledUl, {
    id: id,
    className: className,
    calculatePadding: calculatePadding,
    size: size
  }, ulChildren);
};

UnorderedList.propTypes = propTypes;
UnorderedList.defaultProps = defaultProps;
UnorderedList.displayName = 'UnorderedList';
export default UnorderedList;